import React, { useState, useEffect } from "react";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import { login } from "./redux/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { XCircleIcon } from "@heroicons/react/solid";
import { clearErrors } from "./redux/actions/errors";

export default function Login() {
  const initialData = {
    identifier: "",
    password: "",
  };
  const [showPassword, setShowPassword] = useState(false);
  const [inputData, setInputData] = useState(initialData);

  const { password } = inputData;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoading, user } = useSelector((state) => state.auth);
  const { msg } = useSelector((state) => state.errors);

  useEffect(() => {
    if (!isLoading && user !== null) {
      console.log("hgfhg", user.accountType, " isLoading ", isLoading);
      if (user.accountType === "manager") {
        navigate(`/manager`);
      }
      if (user.accountType === "admin") {
        navigate("/admin");
      }
    }
  }, [isLoading, navigate, user]);

  const handleLoginClick = (e) => {
    e.preventDefault();

    dispatch(login(inputData));
  };

  return (
    <div className="flex justify-center items-center h-screen bg-white">
      <div className="flex-1 flex flex-col justify-center px-4 pt-6 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div className="flex items-center justify-center">
            <h2 className="ml-2 text-2xl text-sky-500">EVD Management</h2>
          </div>

          <div className="mt-8">
            {msg !== null && (
              <div className="rounded-md bg-red-50 p-4 mt-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <XCircleIcon
                      onClick={() => dispatch(clearErrors())}
                      className="h-5 w-5 text-red-400"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">
                      Unable to login.
                    </h3>
                    <div className="mt-2 text-sm text-red-700">{msg.msg}</div>
                  </div>
                </div>
              </div>
            )}
            <div className="mt-6">
              <form onSubmit={handleLoginClick} className="space-y-6">
                <div>
                  <label
                    htmlFor="identifier"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Username
                  </label>
                  <div className="mt-1">
                    <input
                      id="identifier"
                      name="identifier"
                      type="text"
                      autoComplete="identifier"
                      required
                      onChange={handleChange}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="space-y-1">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Password
                  </label>
                  <div className="mt-1 flex flex-row">
                    <input
                      id="password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="current-password"
                      required
                      onChange={handleChange}
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-l-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
                    />
                    {password && (
                      <span
                        class="flex items-center bg-slate-200 rounded rounded-l-none border border-l-0 border-gray-300 px-3 font-bold text-gray-500"
                        onClick={handleShowPassword}
                      >
                        {showPassword ? (
                          <EyeOffIcon className="h-5 w-5 text-teal-600" />
                        ) : (
                          <EyeIcon className="h-5 w-5 text-teal-600" />
                        )}
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="text-sm">
                    <a
                      href="#idkwheretogo"
                      className="font-medium text-teal-600 hover:text-teal-500"
                    >
                      Forgot your password?
                    </a>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    onClick={handleLoginClick}
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                  >
                    Sign in
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
